package org.vreo.devicehub.features.userAuthentication.domain

import kotlinx.serialization.Serializable

/**
 * User role, used to define a user type and permissions.
 */
enum class UserRole(val value: Int) {
    USER(0),
    ADMIN(1),
    VREO_USER(2),
    VREO_ADMIN(3),
}

/**
 * User authentication/profile details
 */
@Serializable
data class User(
    // Login credentials
    val email: String,
    val password: String? = null,

    // user details
    val firstName: String,
    val lastName: String,
    val mobileNumber: String? = null,

    // Account management
    val role: Int = UserRole.USER.value,

    // Company info
    val companyName: String? = null,
    val companyAddressStreet: String? = null,
    val companyAddressCity: String? = null,
    val companyAddressPostalCode: String? = null,
    val companyAddressCountry: String? = null,
)